/**
 * The next drops, one square each, in the order the engine would assign
 * them. They appear left to right so a client can watch turns versus leaning.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { groupPicker, leanWeights } from '@trafficpulse/shared';

import type { LeanRow } from './lean-rows';

const COLORS = ['#f59e0b', '#0ea5e9', '#8b5cf6', '#ec4899', '#14b8a6', '#22c55e'];
const SHOWN = 12;

function order(rows: LeanRow[], lean: boolean, drops: number): string[] {
  const ids = rows.map((r) => r.id);
  const weights = lean ? leanWeights(ids, (id) => rows.find((r) => r.id === id)?.score ?? null) : null;
  const pick = groupPicker(ids, weights, 'ROTATE', () => 0);
  return Array.from({ length: Math.min(drops, SHOWN) }, (_, i) => pick(i));
}

export const TurnStrip: FC<{ rows: LeanRow[]; lean: boolean; drops: number }> = ({ rows, lean, drops }) => {
  const ids = rows.map((r) => r.id);
  return (
    <div className="flex flex-wrap items-center gap-1" data-testid="turn-strip" key={lean ? 'lean' : 'turns'}>
      {order(rows, lean, drops).map((id, i) => {
        const at = Math.max(0, ids.indexOf(id));
        return (
          <span
            key={i}
            title={rows[at]?.name}
            className="h-3.5 w-3.5 rounded-[3px] motion-safe:animate-in motion-safe:fade-in-0 motion-safe:zoom-in-75 motion-reduce:opacity-100 fill-mode-both"
            style={{ backgroundColor: COLORS[at % COLORS.length], animationDelay: `${i * 55}ms`, animationFillMode: 'both' }}
          />
        );
      })}
    </div>
  );
};
